export default {
  'oms_report.generate-report': '生成報表',
  'oms_report.report-type.title': '請選擇一個報表',
  'oms_report.report-type.label': '報表',
  'oms_report.report-type.required': '請選擇報表',
  'oms_report.fulfillment_order.summary': 'Fulfillment Order Summary',
  'oms_report.platform_inventory.summary': 'Platform Inventory Summary',
  'oms_report.marketplace_store.label': 'Stores',
  'oms_report.report_date.label': '報表日期',
  'oms_report.marketplace_store.placeholder': '請選擇Stores',
  'oms_report.from-date.label': '開始日期',
  'oms_report.to-date.label': '結束日期',
  'oms_report.packed-date.label': '打包日期',
  'oms_report.date.placeholder': '請選擇日期',
  'oms_report.generating': '正在生成報表',
  'oms_report.skus.label': 'SKU',
  'oms_report.skus.max-warning': '最多選擇{max_cnt}個SKU作篩選',
  'oms_report.skus.copy-and-paste-textarea-placeholder':
    '最多{max_cnt}個SKU（一次輸入多個SKU，請使用","或"換行"作分隔，例如 sku001、sku002。）',
};
